import { Component } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from 'environments/environment';
import { AuthService } from '../../_services';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../../_services/loader.service'; 
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;
import Swal from 'sweetalert2'
import { utils, write, WorkBook } from 'xlsx';  
import { saveAs } from 'file-saver'; 
declare var $: any; 
@Component({
  templateUrl: './vtsStatusDailyCount.component.html',
})

export class  VtsStatusDailyCountComponent{
    address:any
  public prjId: any
  public userId: any
  public startDate: any
  public endDate: any
  public defaultStartDate: any
  public defaultEndDate: any
  public dataRangeModal: any
  public showLoader: boolean
  public vtsDailyCountData: any  
  public vtsDataNotFound=false  
  public search:any;
  public selectedRow : Number;
  currentDateModal:any;
  defStartDt:any;
  defEndDt:any;
  dateRange:any;
  geocoder:any;
  latLngDataList:any;
    VCdate: any;
  constructor(private http : HttpClient , private auth: AuthService, public routes: ActivatedRoute, public router: Router, private loaderService: LoaderService) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    }); 
    var date = new Date();   
    this.currentDateModal=date;
    this.defStartDt = (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate(); 
    this.defEndDt = (date.getFullYear()) + '-' + (date.getMonth()+1) + '-' + date.getDate(); 
    this.dateRange= {beginDate: {year: date.getFullYear(), month: date.getMonth()+1, day: date.getDate()},endDate: {year: date.getFullYear(), month: date.getMonth()+1, day: date.getDate()}}; 
    }

    /*
    * GET VEHICLE STOP HISTORY DEATILS 
    */
    getVtsDailtDataCount(selectedDate) {
        this.loaderService.display(true); 
        this.http.get(environment.apiUrl + 'reports/vehicles/getVtsDailyCount?DEVICEDATE='+selectedDate+"&PRJID="+this.prjId).subscribe(data => {

            console.log('vts data daily count ');
            
        this.vtsDailyCountData = data

          console.log();
          
        if (this.vtsDailyCountData.length > 0){  
            this.loaderService.display(false);
            this.vtsDataNotFound=false
        } else { 
            this.loaderService.display(false);
            this.vtsDataNotFound=true
        }},
        error => {
            this.loaderService.display(false);
            Swal({
            type: 'error',
            title: 'Oops...',
            text: 'An Error Occurred Please Try Again',
            })
        });
    }

   /*
    * Get Index and Select Table Row
    */
   selectRowIndex(data,index){
    this.selectedRow=index;
    this.selectedDate=data.Devicedate
    }

    orgValueChange(date){  
        this.VCdate = date
        this.startDate = moment( this.VCdate ).format('YYYY-MM-DD'); 
        this.getVtsDailtDataCount(this.startDate )
    }


    latitude:any;
    longitude:any;
    selectedDate:any;
    currentVehNo:any;
    viewMapModal(data){ 
        console.log("Data",data)  
        this.latitude=data.lat
        this.longitude=data.lng  
        $("#viewMapModal").modal("show");
        this.currentVehNo=data.vehno  
        this.getRoutMapByVehicle(this.currentVehNo) 
    }
    
    /*
    * get Route by Lat lng
    */
    getRoutMapByVehicle(vehno){ 
        this.googleMap(this.latitude,this.longitude) 
        this.http.get(environment.apiUrl + 'reports/getRouteByVehicle?prjId='+this.prjId+"&startDate="+this.startDate+"&vehicleNo="+vehno).subscribe(data => {
            this.latLngDataList = data   
            //     myLatLng = {lat: this.latitude, lng: this.longitude};
            //     var map = new google.maps.Map(document.getElementById('googleMap'), {
            //     zoom: 14,
            //     center: new google.maps.LatLng(this.latitude, this.longitude), 
            //   });  
            //          for(var i=0; i<myLatLng.length;i++){
            //                   var markers = new google.maps.Marker({
            //                   position: myLatLng,
            //                   map: map,
            //                   title: 'Hello World!'  
            //         }); 
            //    } 
            });
            
    }


    

   /*
    * Get LAT LNg by Address
   */ 
  googleMap(lat, lng) {
      console.log("dynamic latlng", this.latLngDataList)
    var myLatLng ={ 
        lat:lat, 
        lng: lng
       }; 
        var map = new google.maps.Map(document.getElementById('googleMap'), {
        zoom: 10,
        center: myLatLng
       }); 
       var image = 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png';
        var marker = new google.maps.Marker({
            position: myLatLng,
            map: map,
            icon: image 
        }); 
       
    }  

        
   /*
   * This Method Is use to Download the Vehicles Report into Excel File 
   */
   importVehicleStopReport(vehStopData){
    const ws_name = 'vehicleStopReport';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(vehStopData);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'VehicleStopReport.xlsx');
    }s2ab(s){
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xFF;
        };
        return buf;
    }  

  


    ngOnInit() {
        this.prjId = this.auth.getAuthentication().projectId
        this.userId = this.auth.getAuthentication().id
        this.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD'); 
        this.getVtsDailtDataCount(this.startDate);
        this.geocoder = new google.maps.Geocoder; 
    }
}


// WEBPACK FOOTER //
// ./src/app/reports/vtsReport/vtsStatusDailyCount.component.ts